import { LoanChecklistRuleCondition } from 'src/services/loans/types';

export const hasValidEncompassFieldConditions = (
  conditions: LoanChecklistRuleCondition[] | undefined,
): boolean =>
  Boolean(conditions?.length) &&
  conditions!.every(
    (condition) =>
      condition.field.trim().length > 0 && condition.value.trim().length > 0,
  );
